import styled from "styled-components";
import { desktop } from "../BreakPoints";

import * as React from 'react';
import { rawColors } from "../colors/color";

type LoginLayoutProps = {
    leftBackgroundColor?:string,
    rightImageUrl?:string,
    leftSide?:React.ReactNode,
    rightSide?:React.ReactNode
}

export function LoginLayout(props:LoginLayoutProps):JSX.Element
{
    return (
        <LoginLayoutStyling className="login-layout">
            <LeftSide leftBackgroundColor={props.leftBackgroundColor} imageUrl={props.rightImageUrl}>
                {props.leftSide}
            </LeftSide>
            <RightSide rightImageUrl={props.rightImageUrl}>
                {props.rightSide}
            </RightSide>
        </LoginLayoutStyling>
    );
}


export const LoginLayoutStyling = styled.div`
    display: grid;
    grid-template-areas: "center";
    grid-template-columns: 100%;
    width:100%;
    height:100%;

    @media(min-width: ${desktop}px){
        grid-template-areas: "left right";
        min-height: calc(100vh - 240px);
        height: calc(100vh - 60px);
        grid-template-columns: 50% 50%;
    }
`

export const LeftSide = styled.div<{leftBackgroundColor?:string, imageUrl?:string}>`
    grid-area: center;
    display: grid;
    background-color: ${props => props.leftBackgroundColor ? props.leftBackgroundColor : 'beige'};
    align-content: center;
    justify-content:center;
    position: relative;
    overflow: hidden;

    &::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url(${props => props.imageUrl ? props.imageUrl : '/images/office_01.jpg'});
        background-size: cover;
        background-position: center;
        filter: blur(8px) grayscale(100%);
        transform: scale(1.05);
        z-index: 0;
    }

    > * {
        position: relative;
        z-index: 1;
    }

    @media(min-width: ${desktop}px){
        grid-area: left;
        justify-items: end;
        justify-content: end;

        &::before{
            display: none;
        }

        > * {
            position: static;
            z-index: auto;
        }
    }
`

export const RightSide = styled.div<{rightImageUrl?:string}>`
    display:none;

    @media(min-width: ${desktop}px){
        
        display: grid;
        grid-area: right;
        position: relative;
        overflow: hidden;
        align-content: center;
        justify-items: start;
        padding-left: 32px;

        &::before{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: url(${props => props.rightImageUrl ? props.rightImageUrl : '/images/office_01.jpg'});
            background-size: cover;
            background-position: center;
            filter: blur(8px);
            transform: scale(1.05);
            z-index: 0;
        }

        > * {
            position: relative;
            z-index: 1;
        }
    }
`

export const CardLoginWrapper = styled.div`
    width:400px;
`;


export const SpecialHeaderWrapper = styled.div`
    background: white;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    justify-content: space-between;
    margin: 0 22% 0 0;
    padding: .5rem 1rem;

`

export const CardLogin = styled.div`
    background: gray;
    padding: 1rem;
`

export const LoginText = styled.div`
    color: white;
    font-family: "Noto Sans", sans-serif;
    font-weight: 300;
    font-size: 3rem;
    display: grid;
    width: 100%;
    padding:40px;

    @media(min-width: ${desktop}px){
        font-weight: 400;
        font-size: 4rem;
        padding:0;
        width: 75%;
    }
`;

export const AmorgBrand = styled.div`
    color: ${rawColors.gray.dark};
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 32px;
    font-weight: bold;
    gap: 8px;
    
    `